module.exports = __webpack_public_path__ + "img/P.efd86a2c.jpg";